import {AxiosResponse} from 'axios'
import Client from 'core/api/client'
import {Eye} from 'core/api/prescription'
import authHeaders from './authHeaders'
import { IErrorResponse } from './error'

export interface IReactivateSubjectPrescriptionSuccessResponse {
  prescription: {
    /** Prescription id */
    id: string

    /** Timestamp with timezone representing when the prescription was activated. */
    activatedTime: string

    /** Amblyopic eye according to the prescription */
    amblyopicEye: Eye

    /** Flag to determine if this prescription is currently active */
    isActive: boolean,
  }
}

export type IReactivateSubjectPrescriptionResponseBody = IReactivateSubjectPrescriptionSuccessResponse | IErrorResponse;

/**
 * Expected response from PATCH /study/participant/:participantId/prescription/reactivate endpoint
 */
export interface IReactivateSubjectPrescriptionResponse extends AxiosResponse {
  data: IReactivateSubjectPrescriptionResponseBody
}

export function reactivatePrescription(token: string, participantId: string): Promise<IReactivateSubjectPrescriptionResponse> {
  return Client.patch(
    `/study/participant/${participantId}/prescription/reactivate`,
    undefined,
    { ...authHeaders(token), validateStatus: () => true },
  )
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./core/src/api/study_coordinator/reactivatePrescription.ts